const blur = {
  background: {
    light: 'rgba(255, 255, 255, 0.6)',
    dark: 'rgba(52, 64, 84, 0.6)',
  },
  sizing: {
    sm: 'blur(4px)',
    md: 'blur(8px)',
    lg: 'blur(12px)',
    xl: 'blur(20px)',
  },
} as const;

export type BlurDefinition = typeof blur;
export type BlurSizes = keyof BlurDefinition['sizing'];

export default blur;
